export default __webpack_public_path__ + "static/media/favourite.46fcd991.svg";